import React from "react";
import PropTypes from "prop-types";
import { Badge } from "react-bootstrap";
import styled from "styled-components";

const BadgeStyles = styled(Badge)`
  background: ${(props) => props.color || props.theme.red_g} !important;
  margin-left: 10px;
  padding: 7px 15px;
  letter-spacing: 0 !important;
  text-transform: uppercase;
  width: auto !important;
  border-radius: 3px;
  color: #fff;
  display: ${(props) => props.display || "initial"};
  &.success {
    background: ${(props) => props.color || props.theme.green_g} !important;
  }
  &.warning {
    background: ${(props) => props.color || props.theme.gold_g} !important;
  }
  &.round {
    min-width: auto;
    padding: 4px 15px;
    border-radius: 50px;
  }
  &.fixed-width {
    max-width: 110px;
    min-width: 110px;
  }
  @media screen and (max-width: 812px) {
    &.ticket {
      display: inline-block;
      height: 10px !important;
      width: 10px !important;
      min-width: auto !important;
      border-radius: 50% !important;
      padding: 0;
      margin: 0 auto;
      color: transparent !important;
    }
  }
`;
const BadgeComponent = ({ children, className, color, display }) => (
  <BadgeStyles className={className} color={color} display={display}>
    {children}
  </BadgeStyles>
);

BadgeComponent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  display: PropTypes.string
};
export default BadgeComponent;
